import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { HMRC_URL_AUTH, HMRC_GENERATE_ACCESS_TOKEN } from "./actionType";

import {
  hmrcUrlAuthSuccess,
  hmrcUrlAuthFailure,
  hmrcGenerateAccessTokenSuccess,
  hmrcGenerateAccessTokenFailure,
} from "./action";

import {
  hmrcUrlAuthApi,
  hmrcGenerateAccessTokenApi,
} from "../../helpers/fakebackend_helper";

//HMRC_URL_AUTH
function* hmrcUrlAuthSaga() {
  try {
    const response = yield call(hmrcUrlAuthApi);
    yield put(hmrcUrlAuthSuccess(response));
  } catch (error) {
    yield put(hmrcUrlAuthFailure(error));
  }
}

function* watchHmrcUrlAuth() {
  yield takeEvery(HMRC_URL_AUTH, hmrcUrlAuthSaga);
}
//HMRC_GENERATE_ACCESS_TOKEN
function* hmrcGenerateAccessTokenSaga({ payload }) {
  try {
    const response = yield call(hmrcGenerateAccessTokenApi, payload);
    yield put(hmrcGenerateAccessTokenSuccess(response));
  } catch (error) {
    yield put(hmrcGenerateAccessTokenFailure(error));
  }
}

function* watchHmrcGenerateAccessToken() {
  yield takeEvery(HMRC_GENERATE_ACCESS_TOKEN, hmrcGenerateAccessTokenSaga);
}
// Root saga
export default function* hmrcSaga() {
  yield all([fork(watchHmrcUrlAuth), fork(watchHmrcGenerateAccessToken)]);
}
